// src/redux/slices/profileSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// ------------------
// Types
// ------------------
export interface Plan {
  planId: number;
  planName?: string;
  planDesc?: string;
  price?: string;
  rbtPrice?: number;
}

export interface ProfileState {
  subType: string | null;
  albumList: any[];
  planId: number | null;
}

// ------------------
// Load from sessionStorage
// ------------------
// ------------------
// Load from sessionStorage
// ------------------
const loadSession = (): ProfileState => {
  const albumRaw = sessionStorage.getItem("AlbumList");

  let albumList: any[] = [];

  try {
    if (albumRaw && albumRaw !== "undefined") {
      albumList = JSON.parse(albumRaw);
    }
  } catch {
    albumList = []; // fallback if corrupted
  }

  return {
    subType: sessionStorage.getItem("SubType"),
    albumList: albumList,
    planId: sessionStorage.getItem("PlanId")
      ? Number(sessionStorage.getItem("PlanId"))
      : null,
  };
};


// ------------------
// Initial State
// ------------------
const initialState: ProfileState = loadSession();

// ------------------
// Slice
// ------------------
const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setProfileData: (
      state,
      action: PayloadAction<{
        // registeredName: string;
        subType: string;
        albumList: any[];
        plan?: Plan;
      }>
    ) => {
      const { subType, albumList, plan } = action.payload;

      // Save to Redux state
      state.subType = subType;
      state.albumList = albumList;
      state.planId = plan?.planId ?? null;

      // Save to sessionStorage
      sessionStorage.setItem("SubType", subType);
      sessionStorage.setItem("AlbumList", JSON.stringify(albumList));
      sessionStorage.setItem("PlanId", plan?.planId?.toString() || "");
    },

    clearProfile: (state) => {
      state.subType = null;
      state.albumList = [];
      state.planId = null;

      // Clear session storage
      sessionStorage.removeItem("SubType");
      sessionStorage.removeItem("AlbumList");
      sessionStorage.removeItem("PlanId");
    },
  },
});

// ------------------
// Exports
// ------------------
export const { setProfileData, clearProfile } = profileSlice.actions;
export default profileSlice.reducer;
